<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Tooltip & Popover</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <div class="fullblock">
                    <div class="title">Interactive demo</div>




                    <div class="tooltip-container">
                        <b-container fluid>


                            <b-btn id="exButton1" variant="outline-success">Tooltip</b-btn>
                            <b-btn id="exButton2" variant="outline-success">Tooltip on top</b-btn>
                            <b-btn id="exButton3" variant="outline-success">Tooltip on right</b-btn>
                            <b-btn id="exButton4" variant="outline-success">Tooltip on bottom</b-btn>
                            <b-btn id="exButton5" variant="outline-success">Tooltip on left</b-btn>

                            <b-tooltip target="exButton1" title="Tooltip" placement="top"></b-tooltip>
                            <b-tooltip target="exButton2" title="Tooltip on top" placement="top"></b-tooltip>
                            <b-tooltip target="exButton3" title="Tooltip on right" placement="right"></b-tooltip>
                            <b-tooltip target="exButton4" title="Tooltip on bottom" placement="bottom"></b-tooltip>
                            <b-tooltip target="exButton5" title="Tooltip on left" placement="left"></b-tooltip>







                        </b-container>

                        <!-- tooltip-component-1.vue -->
                    </div>

                </div>

                <div class="fullblock">
                    <div class="title">Interactive demo</div>




                    <div class="tooltip-container">

                        <b-btn v-b-popover.hover.top="'I am popover content!'" title="Popover Title">
                            Tooltip on Top
                        </b-btn>

                        <b-btn v-b-popover.hover.right="'I am popover content!'" title="Popover Title">
                            Tooltip on Right
                        </b-btn>

                        <b-btn v-b-popover.hover.bottom="'I am popover content!'" title="Popover Title">
                            Tooltip on Bottom
                        </b-btn>

                        <b-btn v-b-popover.hover.left="'I am popover content!'" title="Popover Title">
                            Tooltip on Left
                        </b-btn>

                    </div>

                </div>




            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    import { Tooltip } from 'bootstrap-vue/es/components';
    import { Popover } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {

            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tooltipandpopover.vue